(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jan-video-trailer-section"] && !Shopify.designMode) return;
  try {
    
  class VideoOverlay {
    constructor(sectionId) {
      this.sectionId = sectionId;

      // Find elements
      this.modal = document.querySelector('[data-modal="' + sectionId + '"]');
      this.video = document.getElementById('video-' + sectionId);
      this.closeButtons = document.querySelectorAll('[data-close-modal="' + sectionId + '"]');

      // Control buttons
      this.playPauseBtn = document.querySelector('[data-play-pause="' + sectionId + '"]');
      this.muteBtn = document.querySelector('[data-mute-toggle="' + sectionId + '"]');
      this.replayBtn = document.querySelector('[data-replay="' + sectionId + '"]');

      // At least modal and video must exist
      if (!this.modal || !this.video) {
        return;
      }

      // Video state
      this.savedTime = 0;
      this.videoContainer = this.modal.querySelector('.modal-video-container');

      this.setupEvents();
    }

    setupEvents() {
      // Open modal - play button trigger
      const playButtonTrigger = document.querySelector('.tv-play-button[data-video-trigger="' + this.sectionId + '"]');
      if (playButtonTrigger) {
        playButtonTrigger.addEventListener('click', () => {
          this.open();
        });
      }

      // Close buttons
      this.closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.close();
        });
      });

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('active')) {
          this.close();
        }
      });

      // Save time
      this.video.addEventListener('timeupdate', () => {
        this.savedTime = this.video.currentTime;
      });

      // Reset on end
      this.video.addEventListener('ended', () => {
        this.savedTime = 0;
        this.updatePlayPauseButton();
      });

      // Update button states on play/pause
      this.video.addEventListener('play', () => {
        this.updatePlayPauseButton();
      });

      this.video.addEventListener('pause', () => {
        this.updatePlayPauseButton();
      });

      // Update mute button on volume change
      this.video.addEventListener('volumechange', () => {
        this.updateMuteButton();
      });

      // Control buttons
      if (this.playPauseBtn) {
        this.playPauseBtn.addEventListener('click', () => this.togglePlayPause());
      }

      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', () => this.toggleMute());
      }

      if (this.replayBtn) {
        this.replayBtn.addEventListener('click', () => this.replay());
      }

      // Touch swipe down to close (mobile)
      this.setupSwipeToClose();
    }

    open() {
      // Lock scroll
      document.body.classList.add('vo-modal-open');

      this.modal.classList.add('active');

      // Restore time
      if (this.savedTime > 0) {
        this.video.currentTime = this.savedTime;
      }

      // Update button states
      this.updateMuteButton();
      this.updatePlayPauseButton();

      // Play
      setTimeout(() => {
        this.video.play().catch(() => {});
      }, 100);
    }

    close() {
      this.savedTime = this.video.currentTime;

      this.video.pause();
      this.modal.classList.remove('active');

      // Reset video container transform (from swipe)
      this.videoContainer.style.transform = '';
      this.modal.style.backgroundColor = '';

      // Unlock scroll
      document.body.classList.remove('vo-modal-open');
    }

    togglePlayPause() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    toggleMute() {
      this.video.muted = !this.video.muted;
    }

    replay() {
      this.video.currentTime = 0;
      this.savedTime = 0;
      this.video.play();
    }

    updatePlayPauseButton() {
      if (!this.playPauseBtn) return;

      const playIcon = this.playPauseBtn.querySelector('.play-icon');
      const pauseIcon = this.playPauseBtn.querySelector('.pause-icon');

      if (this.video.paused) {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      } else {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      }
    }

    updateMuteButton() {
      if (!this.muteBtn) return;

      const unmutedIcon = this.muteBtn.querySelector('.unmuted-icon');
      const mutedIcon = this.muteBtn.querySelector('.muted-icon');

      if (this.video.muted) {
        unmutedIcon.style.display = 'none';
        mutedIcon.style.display = 'block';
      } else {
        unmutedIcon.style.display = 'block';
        mutedIcon.style.display = 'none';
      }
    }

    setupSwipeToClose() {
      let touchStartY = 0;
      let touchCurrentY = 0;
      let isDragging = false;
      const threshold = 60; // Smaller threshold (iOS-like)
      const maxDragDistance = 200; // Don't drag too far

      // Listen on entire modal overlay for swipes
      this.modal.addEventListener('touchstart', (e) => {
        // Don't interfere with video controls or close button
        if (e.target.tagName === 'VIDEO' || e.target.closest('.modal-btn')) return;

        touchStartY = e.touches[0].clientY;
        isDragging = true;
        this.videoContainer.classList.add('dragging');
      }, { passive: true });

      this.modal.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        touchCurrentY = e.touches[0].clientY;
        const deltaY = touchCurrentY - touchStartY;

        // Only allow downward swipes, limit max distance
        if (deltaY > 0) {
          const clampedDelta = Math.min(deltaY, maxDragDistance);

          // Calculate progress (0 to 1)
          const progress = clampedDelta / maxDragDistance;

          // Subtle scale effect (iOS-like)
          const scale = 1 - (progress * 0.1); // Max 10% shrink

          // Fade background slightly
          const opacity = 0.95 - (progress * 0.4); // 0.95 to 0.55

          // Apply transforms
          this.videoContainer.style.transform = 'translateY(' + clampedDelta + 'px) scale(' + scale + ')';
          this.modal.style.backgroundColor = 'rgba(0, 0, 0, ' + opacity + ')';
        }
      }, { passive: true });

      this.modal.addEventListener('touchend', (e) => {
        if (!isDragging) return;

        const deltaY = touchCurrentY - touchStartY;

        // Remove dragging class to re-enable transitions
        this.videoContainer.classList.remove('dragging');

        // Close if swiped down enough
        if (deltaY > threshold) {
          this.close();
        } else {
          // Spring back with animation
          this.videoContainer.style.transform = '';
          this.modal.style.backgroundColor = '';
        }

        isDragging = false;
        touchStartY = 0;
        touchCurrentY = 0;
      }, { passive: true });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoOverlays);
  } else {
    initVideoOverlays();
  }

  function initVideoOverlays() {
    const sections = document.querySelectorAll('.video-overlay-section');
    sections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      new VideoOverlay(sectionId);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
